import {Component, EventEmitter, Output} from '@angular/core';
import {CookieService} from '../../session/cookie.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: []
})
export class CookieBannerComponent {
  @Output() cookieSet = new EventEmitter();

  constructor(
    private readonly cookieService: CookieService
  ) { }

  setCookie() {
    this.cookieService.setCookie('SKVCookieAlert', 'agree', 300);
    this.cookieSet.emit();
  }
}
